import $ from 'jquery';

function Tabs() {
  // desktop tabs
  $('.nav-link').on('click', (event) => {
    event.preventDefault();
    const tabToShow = $(this).attr('href');
    deactivateTabs();
    $(this).addClass('active');
    tabShow(tabToShow);
  });

  // mobile tabs
  fixMobileTabIcons();

  $("[data-toggle='collapse']").on('click', (event) => {
    event.preventDefault();
    const tabToShow = $(this).attr('href');
    // only show if not already active
    $(this).toggleClass('active');
    // deactivateTabs();
    tabToggle(tabToShow);
  });
}

function tabShow(tabId) {
  $(tabId).addClass('show');
}

function tabToggle(tabId) {
  $(tabId).toggleClass('show');
  $('.btn-block .fa-plus').show();
  $('.btn-block .fa-minus').hide();
  $('.btn-block.active .fa-plus').hide();
  $('.btn-block.active .fa-minus').show();
}

function deactivateTabs() {
  $('.collapse').removeClass('show');
  $('.nav-link').removeClass('show active');
  $('.tab-pane').removeClass('show active');
}

function fixMobileTabIcons() {
  $('.link-list-block .btn-block').append('<i class="fa fa-plus"></i>');
  $('.link-list-block .btn-block').append('<i class="fa fa-minus"></i>');
}

export default Tabs;
